import { usePermissions } from '../contexts/PermissionContext';
import { useBusiness } from '../contexts/BusinessContext';

export function usePermissionCheck() {
  const { hasPermission, loading, currentResource } = usePermissions();
  const { role } = useBusiness();

  const canViewAdminDashboard =
    role === 'admin' || currentResource?.is_admin === true;

  return {
    hasPermission,
    isLoading: loading,
    isAdmin: currentResource?.is_admin || false,
    canViewAdminDashboard,
    currentResource,
    canAccess: {
      canViewAppSettings: hasPermission('topLevel.canViewAppSettings'),
      nexusConnect: hasPermission('topLevel.nexusConnect'),
      calendar: hasPermission('calendar.pageAccess'),
      calendarSales: hasPermission('calendar.sales'),
      viewAllBookings: hasPermission('calendar.viewAllBookings'),
      bookingInformation: hasPermission('calendar.bookingInformation'),
      bookingSalesInfo: hasPermission('calendar.bookingSalesInfo'),
      editBookingDetails: hasPermission('calendar.editBookingDetails'),
      bookingMaterials: hasPermission('calendar.bookingMaterials'),
      bookingRatebook: hasPermission('calendar.bookingRatebook'),
      bookingProfitLoss: hasPermission('calendar.bookingProfitLoss'),
      bookingLiabilityWaiver: hasPermission('calendar.bookingLiabilityWaiver'),
      createBookings: hasPermission('calendar.createBookings'),
      calendarMonthView: hasPermission('calendar.monthView'),
      calendarWeekView: hasPermission('calendar.weekView'),
      calendarDayView: hasPermission('calendar.dayView'),
      messages: hasPermission('messages.pageAccess'),
      crm: hasPermission('crm.pageAccess'),
      marketing: hasPermission('marketing.pageAccess'),
      campaigns: hasPermission('campaigns.pageAccess'),
      salesMap: hasPermission('salesMap.pageAccess'),
      payroll: hasPermission('payroll.pageAccess'),
      accountingHub: hasPermission('accountingHub.pageAccess'),
      invoiceSettings: hasPermission('invoiceSettings.pageAccess'),
      supplies: hasPermission('supplies.pageAccess'),
      services: hasPermission('services.pageAccess'),
      resources: hasPermission('resources.pageAccess'),
      salesReports: hasPermission('salesReports.pageAccess'),
      teamReports: hasPermission('teamReports.pageAccess'),
      suppliesUsage: hasPermission('suppliesUsage.pageAccess'),
      settings: hasPermission('settings.pageAccess'),
      tasks: hasPermission('tasks.pageAccess'),
      docsCanComplete: hasPermission('tasks.canComplete'),
      bookings: hasPermission('bookings.pageAccess'),
      proposals: hasPermission('proposals.pageAccess'),
      customers: hasPermission('customers.pageAccess'),
      kpiDashboard: hasPermission('kpiDashboard.pageAccess'),
      automations: hasPermission('automations.pageAccess'),
      invoices: hasPermission('invoices.pageAccess'),
      products: hasPermission('products.pageAccess'),
      giftCards: hasPermission('giftCards.pageAccess'),
      inventory: hasPermission('inventory.pageAccess'),
      projects: hasPermission('projects.pageAccess'),
      expenses: hasPermission('expenses.pageAccess'),
      expensesAppVisibility: hasPermission('expenses.appVisibility'),
      uploadExpense: hasPermission('expenses.uploadExpense'),
    }
  };
} 